export const Button = {
  defaultProps: {
    size: 'md',
    colorScheme: 'brand',
  },
}
